import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import Header from '../parts/Header'
import ApiSubHeader from '../parts/ApiSubHeader'
import * as MyAPI from '../../../utils/MyAPI'
import * as AbstructedApi from '../../../utils/AbstructedApi'
import * as UserActions from '../../../actions/UserActions'

// DocsSideBar
const DocsSideBar = (props) => {

  let navigate = useNavigate();
  let [pathname, setPathname] = useState('');

  useEffect(() => {
    setPathname(window.location.pathname)
  }, [window.location.pathname]);

  return (
    <Col md="2" xs="12" style={{
      // 'backgroundColor': '#0C3966',
      borderRightColor: '#cccccc',
      borderRightStyle: 'solid',
      borderRightWidth: 1,
      // height: '100%',
      minHeight: '100vh',
    }}>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col>

          <Link to="/docs_top" style={{
            textDecoration: 'none',
            fontWeight: pathname === '/docs_top' ? 'bold' : 'normal',
            color: pathname === '/docs_top' ? '#555555' : '#777777',
          }}>
            クイックスタート
          </Link>

        </Col>
      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col>
          <Link to="/docs_reference" style={{
            textDecoration: 'none',
            fontWeight: pathname === '/docs_reference' ? 'bold' : 'normal',
            color: pathname === '/docs_reference' ? '#555555' : '#777777',
          }}>
            APIレファレンス
          </Link>
        </Col>
      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col>
          <Link to="/docs_mini_dict" style={{
            textDecoration: 'none',
            fontWeight: pathname === '/docs_mini_dict' ? 'bold' : 'normal',
            color: pathname === '/docs_mini_dict' ? '#555555' : '#777777',
          }}>
            ミニ辞書登録機能
          </Link>
        </Col>
      </Row>

    </Col>
  )
}

export default DocsSideBar
